export default {
  productID: 'KeystoreV2',
  failed: 'Vorgang fehlgeschlagen',
  success: 'Vorgang erfolgreich',
  loggedOut: 'Abgemeldet',
  signOut: 'Abmelden',
  TFA: '2FA',
  settings: 'Einstellungen',
  signedInAs: 'Angemeldet als',
  login: 'Anmelden',
  home: 'Home',
  yourName: 'Dein Name *',
  yourPasswd: 'Dein Password *',
  errTypeSomething: 'Bitte ausfüllen',
  errTypePasswd: 'Bitte Password angeben',
  submit: 'Absenden',
  reset: 'Reset',
  name: 'Name',
  password: 'Passwort',
  language: 'Sprache',
  deviceName: 'Tokenname',
  darkMode: 'Dark Mode',
};
